function mainSlider() {
    let SlidersArray = []
    $(".main-slider").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray[index] = new Swiper(`.main-slider[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: `.main-slider[data-slider-id="${index}"] .swiper-pagination`,
                type: 'bullets',
                clickable: true,
            },
        })
    })
}

function Sliders() {
    let SlidersArray = []
    $(".slider").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray[index] = new Swiper(`.slider[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: "auto",
            spaceBetween: 0,
            watchSlidesProgress: true,
            preventClicks: true,
            a11y: false,
            noSwipingSelector: "button",
            navigation: {
                nextEl: `.slider[data-slider-id="${index}"] .swiper-button-next`,
                prevEl: `.slider[data-slider-id="${index}"] .swiper-button-prev`,
            },
            pagination: {
                el: `.slider[data-slider-id="${index}"] .swiper-pagination`,
                type: 'bullets',
                clickable: true,
            },
        })
    })
}

function catalogCardSliders() {
    let SlidersArray = []
    $(".card-slider").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray[index] = new Swiper(`.card-slider[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: "auto",
            spaceBetween: 0,
            // effect: 'fade',
            // allowTouchMove: false,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            pagination: {
                el: `.card-slider[data-slider-id="${index}"] .swiper-pagination`,
                type: 'bullets',
                clickable: true,
            },
        })


    })
}

$(document).on('mouseover', '.card-slider .swiper-pagination-bullet', function(e) {
    console.log(true)
    $(this).click()
})

function gallery() {
    var swiper = new Swiper(".gallery .mySwiper", {
        spaceBetween: 0,
        slidesPerView: "auto",
        // freeMode: true,
        // watchSlidesProgress: true,
        direction: "vertical",
        allowTouchMove: false,
        // preventClicks :true,
        // a11y: false,
        breakpoints: {
            320: {
                allowTouchMove: true,
            },
            992: {
                allowTouchMove: false,
            }
        }
    });
    var swiper2 = new Swiper(".gallery .mySwiper2", {
        spaceBetween: 0,
        thumbs: {
            swiper: swiper,
        },
        navigation: {
            nextEl: `.gallery .swiper-button-next`,
            prevEl: `.gallery .swiper-button-prev`,
        },
    });
}

mainSlider()
Sliders()
catalogCardSliders()
gallery()


$(document).on('click', '.card-toggler__item', function(e) {
    setColor(this)
})

function setColor(el) {
    let id = $(el).attr("data-slider")
    $(el).parents(".catalog-item").find(".card-toggler__item").removeClass("_active")
    $(el).addClass("_active")
    $(el).parents(".catalog-item").find(".catalog-card__view").removeClass("_active")
    $(el).parents(".catalog-item").find(`.catalog-card__view[data-slider="${id}"]`).addClass("_active")
}



$(".card-toggler").each(function(index, el) {
    let itemsCount = $(this).find(".card-toggler__item").length
    if (itemsCount > 11) {
        $(this).css("width", "6.25em")
    }
})
